import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BrowserTracing } from '@sentry/angular-ivy';
import * as Sentry from '@sentry/angular-ivy';
import { SentryConstant, ConfigConstant } from '@shared/constants';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://b4a89d23a15445eab253e60956f4987b@o4504882214928384.ingest.sentry.io/4504888340250624",
  enabled: environment.production,
  // App version — lets you see which release each event/replay came from.
  release: `${window.location.hostname}@${ConfigConstant.VERSION}`,
  enableTracing: environment.production,
  ignoreErrors: SentryConstant.IgnoredErrors,
  denyUrls: SentryConstant.DeniedUrls,
  beforeSend: (event) => {
    const frames = (event.exception?.values || []).reduce(
      (all, value) => all.concat(value.stacktrace?.frames || []),
      []
    );
    const fromDeniedScript = frames.some((frame) =>
      SentryConstant.DeniedStackUrls.some((url) => url.test(frame.filename || ''))
    );
    // All our code ships in .js bundles. A stack with no .js frame at all comes from
    // a script the browser injects into the page (Chrome iOS, the Google app, ...).
    const fromInjectedScript = frames.length > 0 && !frames.some((frame) => /\.js(\?|#|$)/.test(frame.filename || ''));
    return fromDeniedScript || fromInjectedScript ? null : event;
  },
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: ['localhost', environment.base_url, environment.socket_url],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    Sentry.replayIntegration({
      // Redact sensitive content: mask all text and block all media by default.
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.production ? 1.0 : 0.1,

  // Session Replay
  // Percentage of all sessions to record (0.1 = 10%).
  replaysSessionSampleRate: environment.production ? 1.0 : 0.1,
  // Percentage of sessions with an error to record (1.0 = 100%).
  replaysOnErrorSampleRate: environment.production ? 1.0 : 0.1,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
